// extracted by mini-css-extract-plugin
module.exports = {"overlay":"AllowPushNotificationsModal_overlay__14N7W","actionButtons":"AllowPushNotificationsModal_actionButtons__17zzM"};